<content-loader
  [baseUrl]="baseUrl"
  [speed]="3"
  [viewBox]="viewBox"
>
  <ng-content></ng-content>
</content-loader>
